export const TASK_TYPES = ['Story', 'Task', 'Subtask', 'Bug', 'Research', 'Documentation', 'Analysis'];

// Named constants for type references
export const TASK_TYPE_STORY = 'Story';
export const TASK_TYPE_TASK = 'Task';
export const TASK_TYPE_SUBTASK = 'Subtask';
export const TASK_TYPE_BUG = 'Bug';
export const TASK_TYPE_RESEARCH = 'Research';
export const TASK_TYPE_DOCUMENTATION = 'Documentation';
export const TASK_TYPE_ANALYSIS = 'Analysis';

export const DEFAULT_TASK_TYPE = TASK_TYPE_TASK;

// Types that support "Add subtask" (parent types)
export const TASK_TYPES_ALLOWING_SUBTASKS = [TASK_TYPE_STORY, TASK_TYPE_TASK];

export const isSubtaskType = (type) => type === TASK_TYPE_SUBTASK;
export const canHaveSubtask = (type) => TASK_TYPES_ALLOWING_SUBTASKS.includes(type);
